import React, { Component } from "react";
import { Spinner } from "reactstrap";
import { Link } from "react-router-dom";
import { SelectedBanksList } from "./user/banks/Selected/SelectedBanks";
import { BanksService, User, UserBank, UserService } from "../generated";

export interface State {
  loading: boolean;
  selectedBanks: UserBank[];
  selectedBanksLoading: boolean;
  user: User;
}

export class UserBanks extends Component<{}, State> {
  constructor(props: {}) {
    super(props);

    this.state = {
      loading: true,
      selectedBanks: [],
      selectedBanksLoading: false,
      user: null,
    };
  }

  async getUserDetails() {
    const user = await UserService.userGetUser();

    this.setState({
      user: user.user,
    });
  }

  async getSelectedBanksOnly() {
    this.setState({
      selectedBanksLoading: true,
    });

    const result = await BanksService.banksGetSelected({
      email: this.state.user.email,
    });

    this.setState({
      selectedBanksLoading: false,
      selectedBanks: result,
    });
  }

  async componentDidMount() {
    await this.getUserDetails();
    await this.getSelectedBanksOnly();
  }

  render() {
    return (
      <>
        <div className="border rounded rounded-more overflow-hidden p-5">
          <h2 className="mb-3">Connected banks</h2>
          <div className="d-flex flex-wrap mr-n3">
            {this.state.selectedBanksLoading ? (
              <Spinner />
            ) : (
              <SelectedBanksList
                banks={this.state.selectedBanks}
                allowDelete={false}
                allowEdit={false}
              />
            )}
          </div>
          <Link className="btn btn-primary mt-3 px-3" to="/user/banks">
            {this.state.selectedBanks.length > 0
              ? "Manage"
              : "Add your first banks"}
          </Link>
        </div>
      </>
    );
  }
}
